import i18n from '../../../../../language/i18n';

const DEFAULT_GET_API_RESPONSE_TEXT = (data) => {
    if (!data?.data) return '';
    return (
        data.data.firstname + ' ' + data.data.lastname
    );
}

export default {
    props: {
        value: { type: [Object, Number, String, Array] },
        label: { type: String, default: i18n.t('Common.contact') },
        path: { type: String, default: 'contacts' },
        rules: { type: [String, Array], default: undefined },
        vid: { type: String, default: 'contact' },
        returnObject: { type: Boolean, default: true },
        disabled: { type: Boolean, default: false },
        errors: { type: Array, default: () => [] },
        noDataReload: { type: Boolean, default: false },
        withInputField: { type: Boolean, default: false },
        onlyInputField: { type: Boolean, default: false },
        isFormElement: { type: Boolean, default: false },
        readonly: { type: Boolean, default: false },
        responseData: { type: Function, default: (response) => response.data.data },
        itemText: { type: [String, Function], default: 'data.name' },
        itemValue: { type: String, default: 'id' },
        clearable: { type: Boolean, default: true },
        multiple: { type: Boolean, default: false },
        chips: { type: Boolean, default: false},
        deletableChips: { type: Boolean, default: false},
        mandatoryFilters: undefined,
        apiGetResponseItemText: { type: [String, Function], default: (data) => DEFAULT_GET_API_RESPONSE_TEXT(data) },
        cacheItems: { type: Boolean, default: true },
        withExportButton: { type: Boolean, default: false },
        exportValue: { type: String, default: 'id'},
        exportComponent: { type: String, default: "ContactForm" },
        disableInputSelection: { type: Boolean, default: false },
        showableInputItemsSize: { type: Number, default: undefined },
    },
}
